import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { modestoConfig } from "./data";

export default function ModestoPage() {
  return <CityPageTemplate config={modestoConfig} />;
}